import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    bottom: 0,
    width: '100%',
  },
  sponsorDiv: {
    padding: theme.spacing(3, 0),
    backgroundColor: '#f8f8f8',
    color: '#666666',
    fontWeight: 'bold',
    fontSize: '1.1em',
  },
  footer: {
    // height: '80px',
    backgroundColor: '#303439',
    color: '#b9b9b9',
    '& p': {
      fontSize: '1em',
    },
    padding: theme.spacing(3, 0),
  },
  title: {
    fontWeight: 'bold',
  },
  logo: {
    width: '100%',
  },
  contact: {
    padding: theme.spacing(1, 0),
  },
});

class AdminFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.footer}>
          <Grid item xs={8} style={{ margin: '0 auto', textAlign: 'center' }}>
            <Typography>Copyright© 2021 By InnoN All right Reserved.</Typography>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withRouter(withStyles(styles, { withTheme: true })(AdminFooter));
